import React,{useMemo} from "react";

const KEYPAD =   ({ selectedPorts, componentSourceOptions,  ACUModel,
    setSelectedPorts, savedData, setSavedData, selectedType }) => {

        const selectOptions = (key, value) => {
            setSavedData(prevData => {
                return {
                    ...prevData,
                    KEYPAD:{
                        ...prevData[`KEYPAD`],
                        [key]: value
                    }
                }
            })
        }

        const data=useMemo(()=>{
            return savedData[`KEYPAD`]
        },[savedData])


  return (<ReadersType
        ACUModel={ ACUModel}
        source={componentSourceOptions.readersData}
        component_source={data.component_source?.value }
        setSelectedPorts={setSelectedPorts}
        selectedPorts={selectedPorts}
        selectOptions={selectOptions}
        name={data.name}
        port={data.port}
        mode={data.mode}
        readerType={data.readerType}
        wiegandType={ data.wiegandType}
        enable_crc={data.enable_crc}
        reverse_byte_order={data.reverse_byte_order}
        direction={data.direction}
        enable_buzzer={data.enable_buzzer} />)
}

export default KEYPAD